module.exports = __webpack_public_path__ + "static/elevator-pitch-b05e3bcc0a1fd778a1a8c4c4572927d9.jpg";